var _rect, _text, _path, _circle, _circle2, _path2, _text2, _text3, _text4, _circle3, _path3, _circle4, _circle5, _circle6, _text5, _text6, _text7, _circle7, _path4, _text8, _text9, _text0, _circle8, _path5, _path6, _text1, _text10, _text11, _circle9, _circle0, _path7, _text12, _text13, _text14, _rect2, _circle1, _text15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportControlledImplementationFiveStagePathDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1400,
    height: 550,
    viewBox: "0 0 1400 550",
    role: "img",
    "aria-label": "Controlled implementation desktop path",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1400,
    height: 550,
    rx: 38,
    fill: "#FFFFFF",
    stroke: "#D5E3F2"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 62,
    fill: "#087CFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 13,
    fontWeight: 850,
    letterSpacing: 1.5
  }, "DISCOVER \u2192 CONFIGURE \u2192 IMPORT \u2192 VALIDATE \u2192 AUTOMATE")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148 224H1252",
    stroke: "#BEDAF4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 224,
    r: 48,
    fill: "#087CFF",
    fillOpacity: 0.12,
    stroke: "#087CFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 221,
    r: 10,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153 229l10 10",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 148,
    y: 126,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "01")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 148,
    y: 318,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 23,
    fontWeight: 850
  }, "Discover")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 148,
    y: 351,
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650,
    textAnchor: "middle",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 148,
    dy: 0
  }, "Sites, roles, evidence"), /*#__PURE__*/React.createElement("tspan", {
    x: 148,
    dy: 20
  }, "and owners"))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 224,
    r: 48,
    fill: "#F54291",
    fillOpacity: 0.12,
    stroke: "#F54291"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M409 216h30M409 224h30M409 232h30",
    fill: "none",
    stroke: "#F54291",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 216,
    r: 3,
    fill: "#F4F8FD",
    stroke: "#F54291",
    strokeWidth: 2.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 431,
    cy: 224,
    r: 3,
    fill: "#F4F8FD",
    stroke: "#F54291",
    strokeWidth: 2.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 423,
    cy: 232,
    r: 3,
    fill: "#F4F8FD",
    stroke: "#F54291",
    strokeWidth: 2.2
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 424,
    y: 126,
    textAnchor: "middle",
    fill: "#F54291",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "02")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 424,
    y: 318,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 23,
    fontWeight: 850
  }, "Configure")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 424,
    y: 351,
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650,
    textAnchor: "middle",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 424,
    dy: 0
  }, "Requirement matrix"), /*#__PURE__*/React.createElement("tspan", {
    x: 424,
    dy: 20
  }, "and validity rules"))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 224,
    r: 48,
    fill: "#F5AE35",
    fillOpacity: 0.12,
    stroke: "#F5AE35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M687 236h26v-9M700 209v20m-7-7 7 7 7-7",
    fill: "none",
    stroke: "#F5AE35",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 700,
    y: 126,
    textAnchor: "middle",
    fill: "#F5AE35",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "03")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 700,
    y: 318,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 23,
    fontWeight: 850
  }, "Import")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 700,
    y: 351,
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650,
    textAnchor: "middle",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 700,
    dy: 0
  }, "Allocations and"), /*#__PURE__*/React.createElement("tspan", {
    x: 700,
    dy: 20
  }, "existing records"))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 224,
    r: 48,
    fill: "#4BB5FF",
    fillOpacity: 0.12,
    stroke: "#4BB5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M962 211h22l7 7v20h-29z",
    fill: "none",
    stroke: "#4BB5FF",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M969 226l5 5 10-11",
    fill: "none",
    stroke: "#4BB5FF",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 126,
    textAnchor: "middle",
    fill: "#4BB5FF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "04")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 318,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 23,
    fontWeight: 850
  }, "Validate")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 351,
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650,
    textAnchor: "middle",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 976,
    dy: 0
  }, "Outcomes validated"), /*#__PURE__*/React.createElement("tspan", {
    x: 976,
    dy: 20
  }, "with stakeholders"))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1252,
    cy: 224,
    r: 48,
    fill: "#30D6A1",
    fillOpacity: 0.12,
    stroke: "#30D6A1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 1252,
    cy: 224,
    r: 12,
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1252 206v5m0 26v5M1234 224h5m26 0h5M1239 211l4 4m18 18l4 4m0-26-4 4m-18 18-4 4",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 1252,
    y: 126,
    textAnchor: "middle",
    fill: "#30D6A1",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "05")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 1252,
    y: 318,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 23,
    fontWeight: 850
  }, "Automate")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 1252,
    y: 351,
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650,
    textAnchor: "middle",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1252,
    dy: 0
  }, "Forecasting, scheduling"), /*#__PURE__*/React.createElement("tspan", {
    x: 1252,
    dy: 20
  }, "and passports"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 462,
    width: 880,
    height: 50,
    rx: 16,
    fill: "#E7F8F2"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 294,
    cy: 487,
    r: 6,
    fill: "#30D6A1"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 316,
    y: 493,
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "Governed requirements first. Intelligent automation second.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportControlledImplementationFiveStagePathDesktop);
export default __webpack_public_path__ + "static/media/work-passport-controlled-implementation-five-stage-path-desktop.7deb108a4e2459cd58b04f03e16121cf.svg";
export { ForwardRef as ReactComponent };